import React, { useMemo, useState, useRef, useEffect } from 'react'
import { FaBook, FaThumbsUp, FaThumbsDown, FaRegIdCard, FaBuilding } from 'react-icons/fa'
import { Wrapper, BarStrip, ProgressBar, StepperItem, SelectFieldIcon, TextField, TextFieldIcon, Panel, ModalComponent, SearchableSelectField } from '../_components'
import Table from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'
import { Formik } from 'formik'
import { isNull } from 'lodash'

const steps = [
    "Pending", "Actioned"
]

const SuspensionActionField = (record) => {
    return (
        <div onClick={async () => {
            await localStorage.setItem("link", "suspend_certificate")
            await localStorage.setItem("applicationId", record.value)
            return window.location.reload()
        }} className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
            {`Suspend`}
        </div>
    )
}

const UpliftActionField = (record) => {
    return (
        <div onClick={async () => {
            await localStorage.setItem("link", "uplift_suspension")
            await localStorage.setItem("applicationId", record.value)
            return window.location.reload()
        }} className="cursor-pointer w-auto md:w-400 lg:w-22 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
            {`Uplift Suspension`}
        </div>
    )
}

const handleUpdateApplicationEmail = async (values) => {
    const application_to_update = document.getElementById("application_to_update")?.value

    if (!application_to_update) {
        alert("Application not found.")
        return
    }

    if (!values.assigned_email) {
        alert("Please select an email address.")
        return
    }

    try {
        const response = await Axios.post(process.env.REACT_APP_API_URL + `/api/auth/update_application_email`, {
            application_id: application_to_update,
            assigned_email: values.assigned_email,
            actioned_by: localStorage.getItem("email")
        })

        if (response.data?.success === false) {
            alert(response.data.message || "Failed to update email.")
            return
        }

        if (response.data) {
            alert(response.data.message)
            return window.location.reload()
        }
    } catch (error) {
        const message = error.response?.data?.message
            || (error.response?.data?.errors
                ? Object.values(error.response.data.errors).flat().join(", ")
                : "Failed to update application email.")
        alert(message)
        console.log(error)
    }
}

const QA3SuspensionActionField = (record) => {
    return (
        <div onClick={async () => {
            await localStorage.setItem("link", "suspend_certificate")
            await localStorage.setItem("applicationId", record.value)
            return window.location.reload()
        }} className="cursor-pointer w-auto md:w-400 lg:w-26 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
            {`View Suspension`}
        </div>
    )
}

const QA3UpliftActionField = (record) => {
    return (
        <div onClick={async () => {
            await localStorage.setItem("link", "uplift_suspension")
            await localStorage.setItem("applicationId", record.value)
            return window.location.reload()
        }} className="cursor-pointer w-auto md:w-400 lg:w-22 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
            {`View Uplift`}
        </div>
    )
}

const DetailsField = (record) => {
    return (
        <div onClick={async () => {
            await localStorage.setItem("link", "display")
            await localStorage.setItem("applicationId", record.value)
            return window.location.reload()
        }} className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
            {`View`}
        </div>
    )
}

export default function CertificateManagement() {
    const ref = useRef(null);
    const [records, setRecords] = useState([])
    const [modalRecord, setModalRecord] = useState(null)
    const [upliftings, setUpliftings] = useState([])
    const [level3Records, setLevel3Records] = useState([])
    const [level3Upliftings, setLevel3Upliftings] = useState([])
    const [suspensionsToBeSeenByApprover, setSuspensionsToBeSeenByApprover] = useState([])
    const [upliftingsToBeSeenByApprover, setUpliftingsToBeSeenByApprover] = useState([])
    const [loading, setLoading] = useState(true)
    const [issuedRecords, setIssuedRecords] = useState([])
    const [unFilteredRecords, setUnFilteredRecords] = useState([])
    const [showApplicationDetails, setShowApplicationDetails] = useState(false)
    const [showEmailUpdateModal, setShowEmailUpdateModal] = useState(false)
    const [previousSystemFiles, setPreviousSystemFiles] = useState([])
    const [docSlug, setDocSlug] = useState("")
    const [files, setFiles] = useState([])
    const [auditors, setAuditors] = useState([])

    React.useEffect(() => {
        if (loading) {
            fetchApplications()
        }
    }, [loading])

    const DetailsModal = (record) => {
        return (
            <div onClick={async () => {
                try {
                    const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/auth/itcoapplication/${record.value}`)
                    if (response.data) {
                        setModalRecord(response.data.record)
                        fetchAllDocuments(response.data.record?.id)
                        fetchAllPreviousSystemDocuments(response.data.record?.id)
                    }
                } catch (error) {
                    console.log(error)
                }
                setShowApplicationDetails(true)
            }} className="cursor-pointer w-auto md:w-16 lg:w-20 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
                {`View`}
            </div>
        )
    }

    const fetchAllDocuments = async (applicationId) => {
        try {
            const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/auth/getApplicationFiles/${applicationId}`)
            if (response.data) {
                setFiles(response.data?.data)
            }
        } catch (error) { }
    }

    const previewFile = async (e) => {
        let file_id = e.target.id

        try {
            const email = btoa(localStorage.getItem("email")); // Base64 encode
            const url = process.env.REACT_APP_API_URL + `/api/auth/get_file_details/${file_id}/${email}`
            const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        } catch (error) { }
    }

    const fetchAllPreviousSystemDocuments = async (applicationId) => {
        try {
            const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/auth/getPreviousSystemApplicationFiles/${applicationId}`)
            if (response.data) {
                console.log(response.data)
                setPreviousSystemFiles(response.data?.data)
            }
        } catch (error) {
            console.log(error)
        }
    }

    const viewPreviousSystemDoc = async (entity_name, docSlug) => {
        console.log("go to the basket =>>" + docSlug)
        console.log("go to the basket =>>" + entity_name)

        try {
            const url = process.env.REACT_APP_API_URL + `/api/auth/view_previous_system_doc/${docSlug}/${entity_name}`
            const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        } catch (error) { }
    }

    const fetchAllUsers = async () => {
        try {
            const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/auth/itcouser`)

            const results = (response.data?.records || [])
                .filter(user => user.user_role?.toUpperCase().includes("APPLICANT"))
                .map((result) => {
                    const email = result.email || result.email_address
                    return {
                        id: result.id,
                        label: `${email} (${result.domain || "UG"})`,
                        value: email
                    }
                })
                .filter(entry => entry.value)

            setAuditors(results)
        } catch (error) {
            alert("Server error occurred.")
        }
    }

    const columns = useMemo(() => [
        {
            Header: "#",
            accessor: "recordId"
        },
        {
            Header: "Client",
            accessor: "applicant"
        },
        {
            Header: "Stage",
            accessor: "stage"
        },
        {
            Header: "Email",
            accessor: "email_address"
        },
        {
            Header: "Created On",
            accessor: "date"
        },
        {
            Header: "Action",
            accessor: "id",
            Cell: DetailsModal
        }
    ])

    const QA1SuspendColumns = useMemo(() => [
        {
            Header: "#",
            accessor: "recordId"
        },
        {
            Header: "Client",
            accessor: "applicant"
        },
        {
            Header: "Annual Income",
            accessor: "annual_income"
        },
        {
            Header: "ISIC Codes",
            accessor: "isic_codes"
        },
        {
            Header: "Certificate No.",
            accessor: "certificate_number"
        },
        {
            Header: "Email",
            accessor: "email_address"
        },
        {
            Header: "Created On",
            accessor: "date"
        },
        {
            Header: "Action",
            accessor: "id",
            Cell: SuspensionActionField
        }
    ])

    const QA1UpliftColumns = useMemo(() => [
        {
            Header: "#",
            accessor: "recordId"
        },
        {
            Header: "Client",
            accessor: "applicant"
        },
        {
            Header: "Annual Income",
            accessor: "annual_income"
        },
        {
            Header: "ISIC Codes",
            accessor: "isic_codes"
        },
        {
            Header: "Certificate No.",
            accessor: "certificate_number"
        },
        {
            Header: "Email",
            accessor: "email_address"
        },
        {
            Header: "Created On",
            accessor: "date"
        },
        {
            Header: "Action",
            accessor: "id",
            Cell: UpliftActionField
        }
    ])

    const issuedColumns = useMemo(() => [
        {
            Header: "#",
            accessor: "recordId"
        },
        {
            Header: "Client",
            accessor: "applicant"
        },
        {
            Header: "Issued On",
            accessor: "date"
        },
        {
            Header: "Annual Income",
            accessor: "annual_income"
        },
        {
            Header: "ISIC Codes",
            accessor: "isic_codes"
        },
        {
            Header: "Certificate No.",
            accessor: "certificate_number"
        },
        {
            Header: "Email",
            accessor: "email_address"
        },
        {
            Header: "Action",
            accessor: "id",
            Cell: DetailsModal
        }
    ])

    const QA3SuspendColumns = useMemo(() => [
        {
            Header: "#",
            accessor: "recordId"
        },
        {
            Header: "Client",
            accessor: "applicant"
        },
        {
            Header: "Annual Income",
            accessor: "annual_income"
        },
        {
            Header: "ISIC Codes",
            accessor: "isic_codes"
        },
        {
            Header: "Certificate No.",
            accessor: "certificate_number"
        },
        {
            Header: "Email",
            accessor: "email_address"
        },
        {
            Header: "Created On",
            accessor: "date"
        },
        {
            Header: "Action",
            accessor: "id",
            Cell: QA3SuspensionActionField
        }
    ])

    const QA3UpliftColumns = useMemo(() => [
        {
            Header: "#",
            accessor: "recordId"
        },
        {
            Header: "Client",
            accessor: "applicant"
        },
        {
            Header: "Annual Income",
            accessor: "annual_income"
        },
        {
            Header: "ISIC Codes",
            accessor: "isic_codes"
        },
        {
            Header: "Certificate No.",
            accessor: "certificate_number"
        },
        {
            Header: "Email",
            accessor: "email_address"
        },
        {
            Header: "Created On",
            accessor: "date"
        },
        {
            Header: "Action",
            accessor: "id",
            Cell: QA3UpliftActionField
        }
    ])

    const showStage = (stage_number) => {
        switch (stage_number) {
            case "1":
                return "VERIFICATION";
            case "2":
                return "FINANCE";
            case "3":
                return "AUDITOR";
            case "4":
                return "AUDITOR";
            case "5":
                return "LEVEL 1";
            case "6":
                return "LEVEL 2";
            case "7":
                return "LEVEL 3";
            case "8":
                return "APPROVAL";
            case "9":
                return "APPROVED";
            default:
                return
        }
    }

    const fetchApplications = async () => {
        try {
            const response = await Axios.get(process.env.REACT_APP_API_URL + `/api/auth/itcoapplication`)
            if (response.data) {
                const unfiltered_results = response.data.map((result, index) => {
                    return {
                        recordId: `${index + 1}`,
                        stage: showStage(result.stage),
                        applicant: result.trading_name,
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        certificate_number: moment(result.created_at).format("YYYY") + `-` + result.id,
                        email_address: result.created_by,
                        date: moment(result.created_at).format("DD MMM, YYYY"),
                        status: result.status,
                        id: result.id
                    }
                })

                const results = response.data.map((result, index) => {
                    return {
                        recordId: `${index + 1}`,
                        stage: result.stage,
                        applicant: result.trading_name,
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        certificate_number: moment(result.created_at).format("YYYY") + `-` + result.id,
                        email_address: result.created_by,
                        date: moment(result.created_at).format("DD MMM, YYYY"),
                        status: result.status,
                        id: result.id
                    }
                }).filter(record => {
                    return record.status?.toUpperCase() === "APPROVED"
                })

                const extraresults = response.data.map((result, index) => {
                    return {
                        recordId: `${index + 1}`,
                        stage: result.stage,
                        applicant: result.trading_name,
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        certificate_number: moment(result.created_at).format("YYYY") + `-` + result.id,
                        email_address: result.created_by,
                        date: moment(result.created_at).format("DD MMM, YYYY"),
                        status: result.status,
                        id: result.id
                    }
                }).filter(record => {
                    return record.status?.toUpperCase() === "SUSPENDED"
                })

                const level3records = response.data.map((result, index) => {
                    return {
                        recordId: `${index + 1}`,
                        stage: result.stage,
                        applicant: result.trading_name,
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        certificate_number: moment(result.created_at).format("YYYY") + `-` + result.id,
                        email_address: result.created_by,
                        date: moment(result.created_at).format("DD MMM, YYYY"),
                        status: result.status,
                        qa3_suspension_action: result.qa3_suspension_action,
                        qa3_suspension_lift_action: result.qa3_suspension_lift_action,
                        id: result.id
                    }
                }).filter(record => {
                    return (record.status?.toUpperCase() === "SUSPENDED" && record?.qa3_suspension_action === null && record?.qa3_suspension_action === null)
                })

                const level3extrarecords = response.data.map((result, index) => {
                    return {
                        recordId: `${index + 1}`,
                        stage: result.stage,
                        applicant: result.trading_name,
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        certificate_number: moment(result.created_at).format("YYYY") + `-` + result.id,
                        email_address: result.created_by,
                        date: moment(result.created_at).format("DD MMM, YYYY"),
                        status: result.status,
                        qa3_suspension_action: result.qa3_suspension_action,
                        qa3_suspension_lift_action: result.qa3_suspension_lift_action,
                        id: result.id
                    }
                }).filter(record => {
                    return (record.status?.toUpperCase() === "UPLIFTED" && record?.suspension_lifted_on !== null && record?.qa3_suspension_lift_action === null)
                })

                const suspensions_to_be_seen_by_approver = response.data.map((result, index) => {
                    return {
                        recordId: `${index + 1}`,
                        stage: result.stage,
                        applicant: result.trading_name,
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        certificate_number: moment(result.created_at).format("YYYY") + `-` + result.id,
                        email_address: result.created_by,
                        date: moment(result.created_at).format("DD MMM, YYYY"),
                        status: result.status,
                        qa3_suspension_action: result.qa3_suspension_action,
                        qa3_suspension_lift_action: result.qa3_suspension_lift_action,
                        id: result.id
                    }
                }).filter(record => {
                    return (record.status === null && record?.qa3_suspension_action === "Approval")
                })

                const upliftings_to_be_seen_by_approver = response.data.map((result, index) => {
                    return {
                        recordId: `${index + 1}`,
                        stage: result.stage,
                        applicant: result.trading_name,
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        certificate_number: moment(result.created_at).format("YYYY") + `-` + result.id,
                        email_address: result.created_by,
                        date: moment(result.created_at).format("DD MMM, YYYY"),
                        status: result.status,
                        qa3_suspension_action: result.qa3_suspension_action,
                        qa3_suspension_lift_action: result.qa3_suspension_lift_action,
                        id: result.id
                    }
                }).filter(record => {
                    return (record.status === null && record?.qa3_suspension_lift_action === "Approval")
                })

                const issued_results = response.data.map((result, index) => {
                    return {
                        recordId: `${index + 1}`,
                        stage: result.stage,
                        applicant: result.trading_name,
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        certificate_number: result.certificate_serial_number,
                        email_address: result.created_by,
                        date: moment(result.issued_on).format("DD MMM, YYYY"),
                        status: result.status,
                        certificate_print_date: result.certificate_print_date,
                        id: result.id
                    }
                }).filter(record => {
                    return (record.certificate_number !== null)
                })

                //update the state
                setLevel3Upliftings(level3extrarecords)
                setLevel3Records(level3records)
                setUpliftings(extraresults)
                setRecords(results)
                setSuspensionsToBeSeenByApprover(suspensions_to_be_seen_by_approver)
                setUpliftingsToBeSeenByApprover(upliftings_to_be_seen_by_approver)
                setLoading(false)
                setIssuedRecords(issued_results)
                setUnFilteredRecords(unfiltered_results)
            }
        } catch (error) {
            alert("Server error occured.")
            setLoading(false)
        }
    }

    if (localStorage.getItem("link") === "suspend_certificates" && !localStorage.getItem("role")?.toUpperCase().includes("APPROVER")) {
        return (
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 bg-white text-[#AFC836] font-bold text-lg">
                            {`Suspend Certificate`}
                        </div>

                        <div className="flex flex-col justify-center w-full bg-white">

                            <Table
                                rightButton={false}
                                rightBtnCallback={() => { }}
                                rightButtonLabel={null}
                                label="My Reports"
                                columns={localStorage.getItem("role")?.toUpperCase().includes("QA1") ? QA1SuspendColumns : QA3SuspendColumns}
                                data={localStorage.getItem("role")?.toUpperCase().includes("QA1") ? records : level3Records}
                                hidePagination={false}
                                exportToExcel={() => { }}
                                exportToCSV={() => { }}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
        )
    }

    if (localStorage.getItem("link") === "uplift_suspensions" && !localStorage.getItem("role")?.toUpperCase().includes("APPROVER")) {
        return (
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-1 bg-white text-[#AFC836] font-bold text-lg">
                            {`Uplift Certificate Suspensions`}
                        </div>

                        <div className="flex flex-col justify-center w-full bg-white">

                            <Table
                                rightButton={false}
                                rightBtnCallback={() => { }}
                                rightButtonLabel={null}
                                label="My Reports"
                                columns={localStorage.getItem("role")?.toUpperCase().includes("QA1") ? QA1UpliftColumns : QA3UpliftColumns}
                                data={localStorage.getItem("role")?.toUpperCase().includes("QA1") ? upliftings : level3Upliftings}
                                hidePagination={false}
                                exportToExcel={() => { }}
                                exportToCSV={() => { }}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
        )
    }


    if (localStorage.getItem("link") === "uplift_suspensions" && localStorage.getItem("role")?.toUpperCase().includes("QA3")) {
        return (
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-1 bg-white text-[#AFC836] font-bold text-lg">
                            {`Uplift Certificate Suspensions`}
                        </div>

                        <div className="flex flex-col justify-center w-full bg-white">

                            <Table
                                rightButton={false}
                                rightBtnCallback={() => { }}
                                rightButtonLabel={null}
                                label="My Reports"
                                columns={QA1UpliftColumns}
                                data={upliftings}
                                hidePagination={false}
                                exportToExcel={() => { }}
                                exportToCSV={() => { }}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
        )
    }

    if (localStorage.getItem("role")?.toUpperCase().includes("APPROVER") && localStorage.getItem("link") === "suspend_certificates") {
        return (
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-1 bg-white text-[#AFC836] font-bold text-lg">
                            {`Suspend Certificate (Approver)`}
                        </div>

                        <div className="flex flex-col justify-center w-full bg-white">
                            <Table
                                rightButton={false}
                                rightBtnCallback={() => { }}
                                rightButtonLabel={null}
                                label="Suspensions"
                                columns={QA1SuspendColumns}
                                data={suspensionsToBeSeenByApprover}
                                hidePagination={false}
                                exportToExcel={() => { }}
                                exportToCSV={() => { }}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
        )
    }

    if (localStorage.getItem("role")?.toUpperCase().includes("APPROVER") && localStorage.getItem("link") === "uplift_suspensions") {
        return (
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-1 bg-white text-[#AFC836] font-bold text-lg">
                            {`Uplift Certificate Suspensions`}
                        </div>

                        <div className="flex flex-col justify-center w-full bg-white">

                            <Table
                                rightButton={false}
                                rightBtnCallback={() => { }}
                                rightButtonLabel={null}
                                label="My Reports"
                                columns={QA1UpliftColumns}
                                data={upliftingsToBeSeenByApprover}
                                hidePagination={false}
                                exportToExcel={() => { }}
                                exportToCSV={() => { }}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
        )
    }


    if (localStorage.getItem("link") === "issued_certificates") {
        return (
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-1 bg-white text-[#AFC836] font-bold text-lg">
                            {`Issued Certificates`}
                        </div>

                        <div className="flex flex-col justify-center w-full bg-white">

                            <Table
                                rightButton={false}
                                rightBtnCallback={() => { }}
                                rightButtonLabel={null}
                                label="My Reports"
                                columns={issuedColumns}
                                data={issuedRecords}
                                hidePagination={false}
                                exportToExcel={() => { }}
                                exportToCSV={() => { }}
                            />
                        </div>
                    </div>
                </div>

                <ModalComponent title={`Application Details`} open={showApplicationDetails}>
                    <div className="flex flex-col items-center justify-center text-sm">
                        <div className="flex flex-row">
                            <Panel label="Applicant Particulars" className="gap-2">
                                <div className="grid grid-cols-2 gap-2 items-center">
                                    {modalRecord?.category === "Individual" && [
                                        { label: "Category", value: modalRecord?.category, name: "category" },
                                        { label: "Given Name/ First Name", value: modalRecord?.given_name, name: "given_name" },
                                        { label: "Surname", value: modalRecord?.surname, name: "surname" },
                                        { label: "Other Name", value: modalRecord?.middle_name, name: "other_name" },
                                        { label: "Nationality", value: modalRecord?.nationality, name: "nationality" },
                                        { label: modalRecord?.nationality === "Ugandan" ? "National ID" : "Passport No.", value: modalRecord?.nationality === "Ugandan" ? modalRecord?.national_id : modalRecord?.passport_number, name: "national_id" },
                                        { label: "Taxpayer Identification Number", value: modalRecord?.tin, name: "tin" }
                                    ].map(val => {
                                        return (
                                            <div>
                                                <strong>{val.label}:</strong> {val.value}
                                            </div>
                                        )
                                    })}

                                    {modalRecord?.category === "Company" && [
                                        { label: "Certification Level", value: modalRecord?.certification_level, name: "certification_level" },
                                        { label: "Contact First Name", value: modalRecord?.contact_first_name, name: "contact_first_name" },
                                        { label: "Contact Last Name", value: modalRecord?.contact_last_name, name: "contact_last_name" },
                                        { label: "Other Name", value: modalRecord?.contact_middle_name, name: "contact_middle_name" },
                                        { label: "TIN", value: modalRecord?.tin, name: "tin" },
                                    ].map(val => {
                                        return (
                                            <div>
                                                <strong>{val.label}:</strong> {val.value}
                                            </div>
                                        )
                                    })}
                                </div>

                                <div className="grid grid-cols-2 gap-2 items-center">
                                    {[
                                        { label: "District", value: modalRecord?.district, name: "district" },
                                        { label: "County", value: modalRecord?.county, name: "county" },
                                        { label: "Subcounty", value: modalRecord?.subcounty, name: "subcounty" },
                                        { label: "Parish", value: modalRecord?.parish, name: "parish" },
                                        { label: "Village", value: modalRecord?.village, name: "village" }
                                    ].map(val => {
                                        return (
                                            <div>
                                                <strong>{val.label}:</strong> {val.value}
                                            </div>
                                        )
                                    })}
                                </div>

                                <div className="grid grid-cols-2 gap-2 items-center">
                                    {[
                                        { label: "Date of Incorporation", value: modalRecord?.doc, name: "doc" },
                                        { label: "Name of Entity", value: modalRecord?.entity_name, name: "entity_name" },
                                        { label: "Entity Registration", value: modalRecord?.entity_registration, name: "entity_registration" },
                                        { label: "Entity Type", value: modalRecord?.entity_type, name: "entity_type" },
                                        { label: "BRN", value: modalRecord?.ern, name: "ern" },
                                        { label: "Membership", value: modalRecord?.membership, name: "membership" },
                                        { label: "# Females", value: modalRecord?.no_females, name: "no_females" },
                                        { label: "# Males", value: modalRecord?.no_males, name: "no_males" },
                                        { label: "Service Type", value: modalRecord?.service_type, name: "service_type" },
                                        { label: "Business Trading Name", value: modalRecord?.trading_name, name: "trading_name" },
                                        { label: "Annual Turnover / Income", value: modalRecord?.annual_turnover, name: "annual_turnover" },
                                        { label: "Email", value: modalRecord?.created_by, name: "email" },
                                        { label: "Website", value: modalRecord?.website, name: "website" },
                                    ].map(val => {
                                        return (
                                            <div>
                                                <strong>{val.label}:</strong> {val.value}
                                            </div>
                                        )
                                    })}
                                    <a className="text-blue-500 hover:cursor-pointer" id={modalRecord?.id} onClick={async () => {
                                        setShowApplicationDetails(false)
                                        setShowEmailUpdateModal(true)
                                        fetchAllUsers()
                                    }}>Update Application Email</a>
                                </div>

                                <table className="p-2">
                                    <tbody>
                                        {files?.map((item, index) => {
                                            return (
                                                <tr key={index} className="text-xs p-2 text-center">
                                                    <td className="py-2">{item.name}</td>
                                                    <td className="py-2">
                                                        {/* <a className="bg-red-500 text-xs text-white px-2 py-1" href={item.file} download={item.name}>Download</a> */}
                                                        <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.id} onClick={previewFile}>View File</a>
                                                    </td>
                                                    <td>{moment(item.created_at).format("DD MMM, YYYY")}</td>
                                                </tr>
                                            )
                                        })}

                                        {previousSystemFiles?.map((item, index) => {
                                            return (
                                                <>
                                                    {/* {item.trading_licence_doc !== "" && 
                                        <tr>
                                            <td className="p-1 text-black-500">Trading License</td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("trading_licence_doc"); viewPreviousSystemDoc(item.business_trading_name, "trading_licence_doc");}}>View</a></td>
                                        </tr>
                                    } */}

                                                    {item.it_experience_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">IT Experience</td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("it_experience_doc"); viewPreviousSystemDoc(item.business_trading_name, "it_experience_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.income_tax_clearance_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">Tax Clearance
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("income_tax_clearance_doc"); viewPreviousSystemDoc(item.business_trading_name, "income_tax_clearance_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.owner_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">Ownership
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("owner_doc"); viewPreviousSystemDoc(item.business_trading_name, "owner_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.employee_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">Employees Doc
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("employee_doc"); viewPreviousSystemDoc(item.business_trading_name, "employee_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.strategic_plan_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">Stategic Plan
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("strategic_plan_doc"); viewPreviousSystemDoc(item.business_trading_name, "strategic_plan_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.not_debarred_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">Not Debarred
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("not_debarred_doc"); viewPreviousSystemDoc(item.business_trading_name, "not_debarred_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.address_proof_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">Address Proof
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("address_proof_doc"); viewPreviousSystemDoc(item.business_trading_name, "address_proof_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.iso_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">ISO Doc
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("iso_doc"); viewPreviousSystemDoc(item.business_trading_name, "iso_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.ictau_no_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">ICTAU Doc
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("ictau_no_doc"); viewPreviousSystemDoc(item.business_trading_name, "ictau_no_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.employee_doc_male &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">Male Employee Doc
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("employee_doc_male"); viewPreviousSystemDoc(item.business_trading_name, "employee_doc_male"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.employee_doc_female &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">Female Employee Doc
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("employee_doc_female"); viewPreviousSystemDoc(item.business_trading_name, "employee_doc_female"); }}>View</a></td>
                                                        </tr>
                                                    }
                                                </>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </Panel>
                        </div>

                        <button onClick={async () => {
                            setShowApplicationDetails(false)
                        }} className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center">
                            Close
                        </button>
                    </div>
                </ModalComponent>

                <ModalComponent title={`Update Application Email`} open={showEmailUpdateModal}>
                    <div className="flex flex-col items-center justify-center text-sm">
                        <div className="flex flex-row">
                            <Panel label="Update Application Email" className="gap-2">
                                <div className="grid grid-cols-2 gap-2 items-center">
                                    Trading Name:{modalRecord?.trading_name}
                                </div>

                                <Formik
                                    enableReinitialize
                                    initialValues={{
                                        assigned_email: modalRecord?.created_by || "",
                                        actioned_by: localStorage.getItem("email") || "",
                                    }}
                                    onSubmit={handleUpdateApplicationEmail}
                                >
                                    {({ handleSubmit, isSubmitting }) => {
                                        return (
                                            <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                                                <SearchableSelectField
                                                    name="assigned_email"
                                                    required={true}
                                                    disabled={false}
                                                    options={auditors.map(({ id, label, value }) => {
                                                        return { id, label, value }
                                                    })}
                                                    question="Select Email" />

                                                <input value={modalRecord?.id} hidden="true" name="application_to_update" id="application_to_update" />

                                                <button
                                                    type="submit"
                                                    disabled={isSubmitting}
                                                    className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#278556] text-xs text-white flex items-center justify-center disabled:opacity-50"
                                                >
                                                    Submit
                                                </button>
                                            </form>
                                        )
                                    }}
                                </Formik>
                            </Panel>
                        </div>
                        <button onClick={async () => {
                            setShowEmailUpdateModal(false)
                        }} className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center">
                            Close
                        </button>
                    </div>
                </ModalComponent>
            </Wrapper>
        )
    }

    if (localStorage.getItem("link") === "certificate_progress") {
        return (
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-1 bg-white text-[#AFC836] font-bold text-lg">
                            {`Viewing Application Progress`}
                        </div>

                        <div className="flex flex-col justify-center w-full bg-white">

                            <Table
                                rightButton={false}
                                rightBtnCallback={() => { }}
                                rightButtonLabel={null}
                                label="My Reports"
                                columns={columns}
                                data={unFilteredRecords}
                                hidePagination={false}
                                exportToExcel={() => { }}
                                exportToCSV={() => { }}
                            />
                        </div>
                    </div>
                </div>

                <ModalComponent title={`Application Details`} open={showApplicationDetails}>
                    <div className="flex flex-col items-center justify-center text-sm">
                        <div className="flex flex-row">
                            <Panel label="Applicant Particulars" className="gap-2">
                                <div className="grid grid-cols-2 gap-2 items-center">
                                    {modalRecord?.category === "Individual" && [
                                        { label: "Category", value: modalRecord?.category, name: "category" },
                                        { label: "Given Name/ First Name", value: modalRecord?.given_name, name: "given_name" },
                                        { label: "Surname", value: modalRecord?.surname, name: "surname" },
                                        { label: "Other Name", value: modalRecord?.middle_name, name: "other_name" },
                                        { label: "Nationality", value: modalRecord?.nationality, name: "nationality" },
                                        { label: modalRecord?.nationality === "Ugandan" ? "National ID" : "Passport No.", value: modalRecord?.nationality === "Ugandan" ? modalRecord?.national_id : modalRecord?.passport_number, name: "national_id" },
                                        { label: "Taxpayer Identification Number", value: modalRecord?.tin, name: "tin" }
                                    ].map(val => {
                                        return (
                                            <div>
                                                <strong>{val.label}:</strong> {val.value}
                                            </div>
                                        )
                                    })}

                                    {modalRecord?.category === "Company" && [
                                        { label: "Certification Level", value: modalRecord?.certification_level, name: "certification_level" },
                                        { label: "Contact First Name", value: modalRecord?.contact_first_name, name: "contact_first_name" },
                                        { label: "Contact Last Name", value: modalRecord?.contact_last_name, name: "contact_last_name" },
                                        { label: "Other Name", value: modalRecord?.contact_middle_name, name: "contact_middle_name" },
                                        { label: "TIN", value: modalRecord?.tin, name: "tin" },
                                    ].map(val => {
                                        return (
                                            <div>
                                                <strong>{val.label}:</strong> {val.value}
                                            </div>
                                        )
                                    })}
                                </div>

                                <div className="grid grid-cols-2 gap-2 items-center">
                                    {[
                                        { label: "District", value: modalRecord?.district, name: "district" },
                                        { label: "County", value: modalRecord?.county, name: "county" },
                                        { label: "Subcounty", value: modalRecord?.subcounty, name: "subcounty" },
                                        { label: "Parish", value: modalRecord?.parish, name: "parish" },
                                        { label: "Village", value: modalRecord?.village, name: "village" }
                                    ].map(val => {
                                        return (
                                            <div>
                                                <strong>{val.label}:</strong> {val.value}
                                            </div>
                                        )
                                    })}
                                </div>

                                <div className="grid grid-cols-2 gap-2 items-center">
                                    {[
                                        { label: "Date of Incorporation", value: modalRecord?.doc, name: "doc" },
                                        { label: "Name of Entity", value: modalRecord?.entity_name, name: "entity_name" },
                                        { label: "Entity Registration", value: modalRecord?.entity_registration, name: "entity_registration" },
                                        { label: "Entity Type", value: modalRecord?.entity_type, name: "entity_type" },
                                        { label: "BRN", value: modalRecord?.ern, name: "ern" },
                                        { label: "Membership", value: modalRecord?.membership, name: "membership" },
                                        { label: "# Females", value: modalRecord?.no_females, name: "no_females" },
                                        { label: "# Males", value: modalRecord?.no_males, name: "no_males" },
                                        { label: "Service Type", value: modalRecord?.service_type, name: "service_type" },
                                        { label: "Business Trading Name", value: modalRecord?.trading_name, name: "trading_name" },
                                        { label: "Annual Turnover / Income", value: modalRecord?.annual_turnover, name: "annual_turnover" },
                                        { label: "Email", value: modalRecord?.created_by, name: "email" },
                                        { label: "Website", value: modalRecord?.website, name: "website" },
                                    ].map(val => {
                                        return (
                                            <div>
                                                <strong>{val.label}:</strong> {val.value}
                                            </div>
                                        )
                                    })}
                                    <a className="text-blue-500 hover:cursor-pointer" id={modalRecord?.id} onClick={async () => {
                                        setShowApplicationDetails(false)
                                        setShowEmailUpdateModal(true)
                                        fetchAllUsers()
                                    }}>Update Application Email</a>
                                </div>

                                <table className="p-2">
                                    <tbody>
                                        {files?.map((item, index) => {
                                            return (
                                                <tr key={index} className="text-xs p-2 text-center">
                                                    <td className="py-2">{item.name}</td>
                                                    <td className="py-2">
                                                        {/* <a className="bg-red-500 text-xs text-white px-2 py-1" href={item.file} download={item.name}>Download</a> */}
                                                        <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.id} onClick={previewFile}>View File</a>
                                                    </td>
                                                    <td>{moment(item.created_at).format("DD MMM, YYYY")}</td>
                                                </tr>
                                            )
                                        })}

                                        {previousSystemFiles?.map((item, index) => {
                                            return (
                                                <>
                                                    {/* {item.trading_licence_doc !== "" && 
                                        <tr>
                                            <td className="p-1 text-black-500">Trading License</td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("trading_licence_doc"); viewPreviousSystemDoc(item.business_trading_name, "trading_licence_doc");}}>View</a></td>
                                        </tr>
                                    } */}

                                                    {item.it_experience_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">IT Experience</td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("it_experience_doc"); viewPreviousSystemDoc(item.business_trading_name, "it_experience_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.income_tax_clearance_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">Tax Clearance
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("income_tax_clearance_doc"); viewPreviousSystemDoc(item.business_trading_name, "income_tax_clearance_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.owner_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">Ownership
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("owner_doc"); viewPreviousSystemDoc(item.business_trading_name, "owner_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.employee_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">Employees Doc
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("employee_doc"); viewPreviousSystemDoc(item.business_trading_name, "employee_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.strategic_plan_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">Stategic Plan
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("strategic_plan_doc"); viewPreviousSystemDoc(item.business_trading_name, "strategic_plan_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.not_debarred_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">Not Debarred
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("not_debarred_doc"); viewPreviousSystemDoc(item.business_trading_name, "not_debarred_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.address_proof_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">Address Proof
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("address_proof_doc"); viewPreviousSystemDoc(item.business_trading_name, "address_proof_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.iso_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">ISO Doc
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("iso_doc"); viewPreviousSystemDoc(item.business_trading_name, "iso_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.ictau_no_doc &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">ICTAU Doc
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("ictau_no_doc"); viewPreviousSystemDoc(item.business_trading_name, "ictau_no_doc"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.employee_doc_male &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">Male Employee Doc
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("employee_doc_male"); viewPreviousSystemDoc(item.business_trading_name, "employee_doc_male"); }}>View</a></td>
                                                        </tr>
                                                    }

                                                    {item.employee_doc_female &&
                                                        <tr>
                                                            <td className="p-1 text-black-500">Female Employee Doc
                                                            </td><td> <a className="bg-slate-500 text-xs text-white px-2 py-1 ml-2 cursor-pointer" id={item.business_trading_name} onClick={async () => { setDocSlug("employee_doc_female"); viewPreviousSystemDoc(item.business_trading_name, "employee_doc_female"); }}>View</a></td>
                                                        </tr>
                                                    }
                                                </>
                                            )
                                        })}
                                    </tbody>
                                </table>
                            </Panel>
                        </div>

                        <button onClick={async () => {
                            setShowApplicationDetails(false)
                        }} className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center">
                            Close
                        </button>
                    </div>
                </ModalComponent>

                <ModalComponent title={`Update Application Email`} open={showEmailUpdateModal}>
                    <div className="flex flex-col items-center justify-center text-sm">
                        <div className="flex flex-row">
                            <Panel label="Update Application Email" className="gap-2">
                                <div className="grid grid-cols-2 gap-2 items-center">
                                    Trading Name:{modalRecord?.trading_name}
                                </div>

                                <Formik
                                    enableReinitialize
                                    initialValues={{
                                        assigned_email: modalRecord?.created_by || "",
                                        actioned_by: localStorage.getItem("email") || "",
                                    }}
                                    onSubmit={handleUpdateApplicationEmail}
                                >
                                    {({ handleSubmit, isSubmitting }) => {
                                        return (
                                            <form className="w-full my-2 bg-white" onSubmit={handleSubmit}>

                                                <SearchableSelectField
                                                    name="assigned_email"
                                                    required={true}
                                                    disabled={false}
                                                    options={auditors.map(({ id, label, value }) => {
                                                        return { id, label, value }
                                                    })}
                                                    question="Select Email" />

                                                <input value={modalRecord?.id} hidden="true" name="application_to_update" id="application_to_update" />

                                                <button
                                                    type="submit"
                                                    disabled={isSubmitting}
                                                    className="cursor-pointer mb-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#278556] text-xs text-white flex items-center justify-center disabled:opacity-50"
                                                >
                                                    Submit
                                                </button>
                                            </form>
                                        )
                                    }}
                                </Formik>
                            </Panel>
                        </div>
                        <button onClick={async () => {
                            setShowEmailUpdateModal(false)
                        }} className="cursor-pointer my-3 w-auto md:w-48 lg:w-64 py-1 rounded bg-[#aa314f] text-xs text-white flex items-center justify-center">
                            Close
                        </button>
                    </div>
                </ModalComponent>
            </Wrapper>
        )
    }
}